import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PncCentralCallService {
    protected repoURL = environment.repoUrl;

    private _httpClient = inject(HttpClient);

    /**
     * Constructor
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Call PNC
     *
     * @param id
     * @param user
     */
    // /api/user/pnc-central-call/pnc/{profileId}/external-id/{userExternalId}
    callPNC(profileId, userExternalId): Observable<any> {
        return this._httpClient.post(
            `${this.repoURL}/api/user/pnc-central-call/pnc/${profileId}/external-id/${userExternalId}`,
            {
                profileId,
                userExternalId,
            }
        );
    }
}
